var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#009639",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M195.338 213C190.746 213 186.224 211.213 182.847 207.829L78.3239 103.307V195.34C78.3239 205.095 70.4184 213 60.662 213C50.9126 213 43 205.095 43 195.34V60.6678C43 53.5189 47.3095 47.0834 53.908 44.3496C60.4995 41.6087 68.1012 43.1204 73.1525 48.1784L177.676 152.7V60.6678C177.676 50.9122 185.582 43.0074 195.338 43.0074C205.095 43.0074 213 50.9122 213 60.6678V195.34C213 202.481 208.69 208.924 202.092 211.658C199.909 212.562 197.62 213 195.338 213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/Nginx.a813f8be95ce0b24215c1de7276a557a.svg";
export { ForwardRef as ReactComponent };